import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { TransferState, makeStateKey } from '@angular/core';

// ngrx store
import { Store } from '@ngrx/store';
import { Subscription, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

// models
import { AppState } from '../../booking/models/app-state.interface';

// globals
import { API_PATH, GET_ALL_AIRPORTS, SUBSCRIPTION_KEY, VALIDATE_POSTCODES, GET_ALL_POSTCODES, GET_BLOCKED_POSTCODES, SLOT_NUMBER } from '../../shared/globals';

const AIRPORT_DATA = makeStateKey('airport_data');
const BLOCKED_POSTCODE_DATA = makeStateKey ('blocked_postcode_data');

let airportData = null;
let postcodeData = null;
let adminUsers = null;
let prevAirportCityName = '';
let isCityChange = true;
let blockedPostcodeData = null;
let blockedPostcodeDataClient = null;

@Injectable({
  providedIn: 'root',
})
export class SharedService {

  private _httpBlockedPostcodeSubscription: Subscription;
  private _httpPostcodeSubscription: Subscription;
  private _airportSubscription: Subscription;
  private _airportFallbackSubscription: Subscription;

  public challengeShopperSubject$: Subject<any> = new Subject<any>();

  constructor(
    private _http: HttpClient,
    private _serverState: TransferState,
    private _appStore: Store<AppState>
  ) {}

  getAirports(fallback?, callback?) {

    if (!fallback) {
      airportData = this._serverState.get(AIRPORT_DATA, null as any);
      // data null on the server
      // server should do api call and pass data into state to transfer
      if (airportData === null) {

    //  const headers = new HttpHeaders();
    //   headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

       let headers = new HttpHeaders()
       headers=headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);


        this._airportSubscription = this._http.get(API_PATH + GET_ALL_AIRPORTS + '?cache=' + (Math.random() * 1000000),{headers:headers})
          .subscribe(
            (res:any) => {
              this._serverState.set(AIRPORT_DATA, {hasError: false, data: res} as any);
              this._airportSubscription.unsubscribe();
            },
            err => {
              this._serverState.set(AIRPORT_DATA, {hasError: true, data: err} as any);
            });
      } else {
        return airportData;
      }
    } else {
      this._airportSubscription.unsubscribe();
      // if data failed on server
      // call again in client
      // pass data back inn callback
      // const headers = new HttpHeaders();
      // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

      let headers = new HttpHeaders()
      headers=headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

      this._airportFallbackSubscription = this._http.get(API_PATH + GET_ALL_AIRPORTS + '?cache=' + (Math.random() * 1000000),{headers:headers})
        .subscribe(
          (res:any) => {
            callback({hasError: false, data: res});
            this._airportFallbackSubscription.unsubscribe();
          },
          err => {
            callback({hasError: true, data: err});
            this._airportFallbackSubscription.unsubscribe();
          });
    }
  }

  validatePostcode(postcode, callback?) {

    const flightData = this.getState(this._appStore).flightReducer.flightDetails.flightResponse;

    const request = {
      postCode: postcode,
      airportCode: '',
      slotNumber :  this.getCurrentSlotNumber(),
      airline: flightData.flightStatusDetails[0].airlineCode
    };

    if (Object.keys(flightData).length > 0) {

      if (flightData.flightDirection === 1) {
        request.airportCode = flightData.flightStatusDetails[0].departureAirport.airportCode;
      } else {
        request.airportCode = flightData.flightStatusDetails[flightData.flightStatusDetails.length - 1].arrivalAirport.airportCode;
      }
    }

    // const headers = new HttpHeaders();

    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    const headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    this._httpPostcodeSubscription = this._http.post(API_PATH + VALIDATE_POSTCODES + '?cache=' + (Math.random() * 1000000), request,{headers:headers})
      .subscribe((res:any) => {
        postcodeData = {hasError: false, data: res};
        if (callback) {
          callback(postcodeData);
        }

        this._httpPostcodeSubscription.unsubscribe();
      },
      err => {
        postcodeData = {hasError: true, data: err};
        callback(postcodeData);
      });
  }

  // to help stop booking notes failing
  // after getting admin users store here
  savedAdminUsers(arr) { adminUsers = arr; }
  // then retrieve, if needed
  getAdminUsers() { return adminUsers; }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
    .subscribe(s => state = s);
    return state;
  }

  getCurrentSlotNumber() {
    const state = this.getState(this._appStore);
    const bookingType = state.bookingReducer.bookingDetails.bookingType;

    console.log("bookingType ", bookingType);

    if (bookingType === 'amend') {
      const currentBookingSlotNumber = state.currentBookingReducer.currentBooking?.slotNumber;
      console.log("slotNumber ", currentBookingSlotNumber);
      return currentBookingSlotNumber;
    } else {
      console.log("SLOT_NUMBER ", SLOT_NUMBER);
      return SLOT_NUMBER;
    }
  }

}
